<div
    #portalConversationResolver
    class="conversation react-wrapper"
  ></div>